export const DateFormats: string[] = [
  'M/d/yyyy',
  'M/d/yy',
  'MM/dd/yy',
  'MM/dd/yyyy',
  'dd/MM/yy',
  'dd/MM/yyyy',
  'dd-MMM-yy',
  'yy/MM/dd',
  'yyyy-MM-dd',
];
